export default __webpack_public_path__ + "static/media/FOTO-12.6793e025.jpg";